/** Clave estable para comparar ids de clínica (JWT vs persistidos en minúscula). */
export function clinicIdKey(id: string): string {
  return id.trim().replace(/[{}]/g, '').toLowerCase();
}

export function sameClinicIds(left: string[], right: string[]): boolean {
  if (left.length !== right.length) return false;
  const set = new Set(left.map(clinicIdKey));
  return right.every((id) => set.has(clinicIdKey(id)));
}

export function isClinicSelected(selected: string[], clinicId: string): boolean {
  const target = clinicIdKey(clinicId);
  return selected.some((id) => clinicIdKey(id) === target);
}

export function toggleClinicSelection(selected: string[], clinicId: string): string[] {
  if (isClinicSelected(selected, clinicId)) {
    return selected.filter((id) => clinicIdKey(id) !== clinicIdKey(clinicId));
  }
  return [...selected, clinicId];
}

/** Reescribe ids asignados con la grafía del scope del dueño (la de los checkboxes). */
export function alignClinicIdsToScope(assigned: string[], ownerClinics: string[]): string[] {
  const byKey = new Map(ownerClinics.map((id) => [clinicIdKey(id), id]));
  const seen = new Set<string>();
  const aligned: string[] = [];
  for (const id of assigned) {
    const ownerId = byKey.get(clinicIdKey(id));
    if (!ownerId) continue;
    const key = clinicIdKey(ownerId);
    if (seen.has(key)) continue;
    seen.add(key);
    aligned.push(ownerId);
  }
  return aligned;
}
